import { render, staticRenderFns } from "./ejecucion-acpm-investigaciones.vue?vue&type=template&id=586be8ec&"
import script from "./ejecucion-acpm-investigaciones.vue?vue&type=script&lang=js&"
export * from "./ejecucion-acpm-investigaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports